export const FETCH_INTERVENTIONS_WITH_PAGINATION =
  'app/CopyModal/FETCH_INTERVENTIONS_WITH_PAGINATION';

export const FETCH_INTERVENTIONS_WITH_PAGINATION_SUCCESS =
  'app/CopyModal/FETCH_INTERVENTIONS_WITH_PAGINATION_SUCCESS';

export const FETCH_SESSIONS_REQUEST = 'app/CopyModal/FETCH_SESSIONS_REQUEST';
export const FETCH_SESSIONS_SUCCESS = 'app/CopyModal/FETCH_SESSIONS_SUCCESS';
export const FETCH_SESSIONS_ERROR = 'app/CopyModal/FETCH_SESSION_ERROR';

export const FETCH_QUESTION_GROUPS_REQUEST =
  'app/CopyModal/FETCH_QUESTION_GROUPS_REQUEST';
export const FETCH_QUESTION_GROUPS_SUCCESS =
  'app/CopyModal/FETCH_QUESTION_GROUPS_SUCCESS';
export const FETCH_QUESTION_GROUPS_ERROR =
  'app/CopyModal/FETCH_QUESTION_GROUPS_ERROR';

export const CHANGE_VIEW = 'app/CopyModal/CHANGE_VIEW';
